import React, { useState, useEffect } from 'react'
// ** React Imports
import { Outlet } from "react-router-dom"
import { Clipboard, BarChart, Search, Home, Mail } from "react-feather"
// ** Core Layout Import
// !Do not remove the Layout import
import Layout from "@layouts/VerticalLayout"
import { isUserLoggedIn } from "@utils"
import { Icon } from '@react-pdf-viewer/core'
// import themeConfig from '../configs/themeConfig'
import { useSelector } from "react-redux"
import themeConfig from '../configs/themeConfig'
// ** Menu Items Array
// import navigation from "@src/navigation/vertical"

const VerticalLayout = (props) => {
  const stores = useSelector((state) => state.commonreducerSlice)
  const [menusData, setMenuData] = useState([])

  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  function collectHierarchyForDocuments(data) {
    const hierarchy = []
    for (const item of data) {
      if (item.children.length === 0 && item.documents.length > 0) {
        const documents = item.documents
        const newDocuments = []
        for (let i = 0; i < documents.length; i++) {
          const element = documents[i]
          newDocuments.push({
            value: element.id,
            label: element.fileDisplayName,
            id: element.id,
            parentId: element.id,
            name: <div className=''>{element.fileDisplayName}</div>,
            isExpanded: (item ? (item.isExpanded ? checkBool : false) : false),
            isChecked: false,
            isChildrenLoading: false,
            contentType: "Document",
            isOpen: false,
            sharePointListData: element,
            children: []
          })
        }
        hierarchy.push({
          value: item.id,
          label: item.fileName,
          id: item.id,
          parentId: item.id,
          isExpanded: (item ? (item.isExpanded ? checkBool : false) : false),
          isChecked: false,
          isChildrenLoading: false,
          contentType: "Folder",
          sharePointListData: { linkFilename: item.fileName },
          name: <div className=''>{item.fileName}</div>,
          isOpen: false,
          children: newDocuments
        })
      } else if (item.children.length > 0) {
        const childHierarchy = collectHierarchyForDocuments(item.children)
        if (childHierarchy.length > 0) {
          if (item.documents.length > 0) {
            const documents = item.documents
            for (let i = 0; i < documents.length; i++) {
              const element = documents[i]
              childHierarchy.push({
                value: element.id,
                label: element.fileDisplayName,
                id: element.id,
                parentId: element.id,
                name: <div className=''>{element.fileDisplayName}</div>,
                isExpanded: (item ? (item.isExpanded ? checkBool : false) : false),
                isChecked: false,
                isChildrenLoading: false,
                contentType: "Document",
                isOpen: false,
                sharePointListData: element,
                children: []
              })
            }
          }
          hierarchy.push({
            value: item.id,
            label: item.fileName,
            id: item.id,
            parentId: item.id,
            isExpanded: (item ? (item.isExpanded ? checkBool : false) : false),
            isChecked: false,
            isChildrenLoading: false,
            contentType: "Folder",
            sharePointListData: { linkFilename: item.fileName },
            name: <div className=''>{item.fileName}</div>,
            isOpen: false,
            children: childHierarchy
          })
        }

      }
    }
    return hierarchy
  }

  useEffect(() => {
    if (isUserLoggedIn()) {
      const menuData = [
        {
          id: "home",
          title: "Home",
          icon: <Home size={16} className="top-menu-icon" />,
          color1: "#fff",
          color2: "#313131",
          navLink: "/home",
          show: true,
          type: "link"
        },
        {
          id: "contact-us",
          title: "Contact Us",
          icon: <Mail size={16} className="top-menu-icon" />,
          color1: "#fff",
          color2: "#313131",
          navLink: "/contact-us",
          show: true,
          type: "link"
        }
      ]

      if (stores.onlineLibraryFiles && stores.onlineLibraryFiles.length > 0) {
        const filteredfolder = collectHierarchyForDocuments(stores.onlineLibraryFiles)
        // const sortedFolder = [...filteredfolder].sort((a, b) => a.label.localeCompare(b.label))
        const sortedFolder = [...filteredfolder].filter(item => item.label !== "RLM 300").sort((a, b) => a.label.localeCompare(b.label))
        console.log(sortedFolder, 'sortedFolder')
        menuData.splice(1, 0, {
          id: "publications",
          title: "RLM 300",
          icon: (
            <img
              src={themeConfig.navicons.subscriptions}
              alt="publications"
              className="top-menu-icon"
              style={{ marginRight: '18px' }}
            />
          ),
          color1: "#fff",
          color2: "#313131",
          navLink: "",
          children: sortedFolder.map((item) => ({
            id: item.label,
            title: item.label,
            navLink: `/library?label=${item.label}`,
            show: true
          })),
          show: true
        })
      }

      setMenuData(menuData)
    }
  }, [isUserLoggedIn(), stores.onlineLibraryFiles])


  return (
    <Layout menuData={menusData} {...props}>
      <Outlet />
    </Layout>
  )
}

export default VerticalLayout
